import React, { useState, useRef } from 'react'
// import './style.scss'
import axios from 'axios'
import { Icon } from 'react-icons-kit'
import { toast } from 'react-toastify'
import { Link } from 'react-router-dom'
import { api } from '../../../utils/api'
import { useForm } from 'react-hook-form'
import 'react-toastify/dist/ReactToastify.css'
import { chevronLeft } from 'react-icons-kit/feather'
import { useNavigate } from 'react-router-dom'

//toast.configure({ autoClose: 2000 })
const GhotokAccount = () => {
    const { register, handleSubmit, watch, formState: { errors } } = useForm()
    const [isLoading, setLoding] = useState(false)
    const password = useRef({});
    password.current = watch("password", "");

    const navigate = useNavigate()
    const goToPreviousPath = () => {
        navigate.goBack()
    }
    const [header] = useState({
        headers: { Authorization: "Bearer " + localStorage.getItem('token') }
    })


    // Submit Form
    const onSubmit = async (data) => {
        try {
            setLoding(true)
            let formData = new FormData();
            formData.append("name", data.name);
            formData.append("fbPageUrl", data.fbPageUrl);
            formData.append("email", data.email);
            formData.append("whatsappOrImo", data.whatsappOrImo);
            formData.append("phone", data.phone);
            formData.append("gender", data.gender);
            formData.append("mobileNumberFor", data.mobileNumberFor);
            formData.append("address", data.address);
            formData.append("referenceWay", data.referenceWay);
            formData.append("mobileBankingNumber", data.mobileBankingNumber);
            formData.append("password", data.password);
            formData.append("NIDNo", data.NIDNo);
            formData.append("profileImage", data.profileImage[0]);
            formData.append("NIDImage", data.NIDImage[0]);
            formData.append("anyBillCopy", data.anyBillCopy[0]);
            
            const response = await axios.post(`${api}ghotok/account/create`, formData, header)
            if (response.status === 201) {
                let Id = response.data.GhotokId;
                
                setLoding(false)
                toast.success("Agent account created successfully.")
                navigate(`/dashboard/agents/${Id}/phone-verified`)
            }
        } catch (error) {
            setLoding(false)
            if (error) {
                toast.error(error.response.data.message)
            }
        }
    }

    return (
        <div className="create-membership-package">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 col-padding mb-2">
                        <div className="card border-0 shadow-sm">
                            <div className="card-header bg-white p-md-4">
                                <div className="d-flex">
                                    <div><h5 className="mt-2 mb-0">Create Agents</h5></div>
                                    <div className="ml-auto">
                                        <button
                                            onClick={goToPreviousPath}
                                            type="button"
                                            className="btn shadow-none back-btn"
                                        ><Icon icon={chevronLeft} size={18} />Back</button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body p-md-4">
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <div className="row">

                                        {/* Name */}
                                        <div className="col-12 col-lg-6">
                                            <div className="form-group mb-4">
                                                {errors.name ? (
                                                    <p className="text-danger">{errors.name.message}</p>
                                                ) : <p>Name</p>}

                                                <input
                                                    type="text"
                                                    placeholder="Enter name"
                                                    className={errors.name ? "form-control shadow-none error" : "form-control shadow-none"}
                                                    {...register("name", { required: "Name is required" })}
                                                />
                                            </div>
                                        </div>

                                        {/* Facebook */}
                                        <div className="col-12 col-lg-6">
                                            <div className="form-group mb-4">
                                                {errors.fbPageUrl ? (
                                                    <p className="text-danger">{errors.fbPageUrl.message}</p>
                                                ) : <p>Facebook Id</p>}

                                                <input
                                                    type="text"
                                                    placeholder="Enter Facebook Id"
                                                    className={errors.fbPageUrl ? "form-control shadow-none error" : "form-control shadow-none"}
                                                    {...register("fbPageUrl", { required: "Facebook Id is required" })}
                                                />
                                            </div>
                                        </div>

                                        {/* Email */}
                                        <div className="col-12 col-lg-6">
                                            <div className="form-group mb-4">
                                                {errors.email ? (
                                                    <p className="text-danger">{errors.email.message}</p>
                                                ) : <p>Email</p>}

                                                <input
                                                    type="email"
                                                    placeholder="Enter email"
                                                    className={errors.email ? "form-control shadow-none error" : "form-control shadow-none"}
                                                    {...register("email", { required: "Email is required" })}
                                                />
                                            </div>
                                        </div>

                                        {/* WhatsApp Or Imo*/}
                                        <div className="col-12 col-lg-6">
                                            <div className="form-group mb-4">
                                                {errors.whatsappOrImo ? (
                                                    <p className="text-danger">{errors.whatsappOrImo.message}</p>
                                                ) : <p>WhatsApp Or Imo</p>}

                                                <input
                                                    type="text"
                                                    placeholder="Enter WhatsApp Or Imo Number"
                                                    className={errors.whatsappOrImo ? "form-control shadow-none error" : "form-control shadow-none"}
                                                    {...register("whatsappOrImo", { required: "WhatsApp Or Imo Number is required" })}
                                                />
                                            </div>
                                        </div>

                                        {/* Phone Number*/}
                                        <div className="col-12 col-lg-6">
                                            <div className="form-group mb-4">
                                                {errors.phone ? (
                                                    <p className="text-danger">{errors.phone.message}</p>
                                                ) : <p>Phone Number</p>}

                                                <input
                                                    type="text"
                                                    placeholder="Enter Phone Number"
                                                    className={errors.phone ? "form-control shadow-none error" : "form-control shadow-none"}
                                                    {...register("phone", { required: "Phone is required" })}
                                                />
                                            </div>
                                        </div>

                                        {/* Address */}
                                        <div className="col-12 col-lg-6">
                                            <div className="form-group mb-4">
                                                {errors.address ? (
                                                    <p className="text-danger">{errors.address.message}</p>
                                                ) : <p>Address</p>}

                                                <input
                                                    type="text"
                                                    placeholder="Enter Address"
                                                    className={errors.address ? "form-control shadow-none error" : "form-control shadow-none"}
                                                    {...register("address", { required: "Address is required" })}
                                                />
                                            </div>
                                        </div>

                                         {/* Gender */}
                                         <div className="col-12 col-lg-6">
                                            <div className="form-group mb-4">
                                                {errors.gender ? (
                                                    <p className="text-danger">{errors.gender.message}</p>
                                                ) : <p>Gender</p>}

                                                <select
                                                    className={errors.gender ? "form-control shadow-none error" : "form-control shadow-none"}
                                                    {...register("gender", { required: "Gender is required" })}
                                                >
                                                    <option value="Male">Male</option>
                                                    <option value="Female">Female</option>
                                                </select>
                                            </div> 
                                        </div> 

                                        {/*Reference Way*/}
                                        <div className="col-12 col-lg-6">
                                            <div className="form-group mb-4">
                                                {errors.referenceWay ? (
                                                    <p className="text-danger">{errors.referenceWay.message}</p>
                                                ) : <p>Reference Way</p>}

                                                <input
                                                    type="text"
                                                    placeholder="Enter Reference Way"
                                                    className={errors.referenceWay ? "form-control shadow-none error" : "form-control shadow-none"}
                                                    {...register("referenceWay", { required: "Reference Way is required" })}
                                                />
                                            </div>
                                        </div>

                                        {/*Mobile Banking Informations*/}
                                        <div className="col-12 col-lg-6">
                                            <div className="form-group mb-4">
                                                {errors.mobileBankingNumber ? (
                                                    <p className="text-danger">{errors.mobileBankingNumber.message}</p>
                                                ) : <p>Mobile Banking Informations</p>}

                                                <input
                                                    type="text"
                                                    placeholder="Enter Mobile Banking Informations"
                                                    className={errors.mobileBankingNumber ? "form-control shadow-none error" : "form-control shadow-none"}
                                                    {...register("mobileBankingNumber", { required: "Mobile Banking Informations is required" })}
                                                />
                                            </div>
                                        </div>

                                        {/* Phone Number For */}
                                        <div className="col-12 col-lg-6">
                                            <div className="form-group mb-4">
                                                {errors.mobileNumberFor ? (
                                                    <p className="text-danger">{errors.mobileNumberFor.message}</p>
                                                ) : <p>Phone Number For</p>}

                                                <select
                                                    className={errors.mobileNumberFor ? "form-control shadow-none error" : "form-control shadow-none"}
                                                    {...register("mobileNumberFor", { required: "Phone Number is required" })}
                                                >
                                                    <option value="Bkash">Bkash</option>
                                                    <option value="Nagad">Nagad</option>
                                                    <option value="Rocket">Rocket</option>
                                                </select>
                                            </div> 
                                        </div> 

                                        {/* Password */}
                                        <div className="col-12 col-lg-6">
                                            <div className="form-group mb-4">
                                                {errors.password ? (
                                                    <p className="text-danger">{errors.password.message}</p>
                                                ) : <p>Password</p>}

                                                <input
                                                    type="password"
                                                    placeholder="Enter password"
                                                    className={errors.password ? "form-control shadow-none error" : "form-control shadow-none"}
                                                    {...register("password", {
                                                        required: "Password is required",
                                                    })}
                                                />
                                            </div>
                                        </div>

                                       {/* Confirm Password */}
                                       <div className="col-12 col-lg-6">
                                            <div className="form-group mb-4">
                                                {errors.confirmPassword ? (
                                                    <p className="text-danger">{errors.confirmPassword.message}</p>
                                                ) : <p>Confirm Password</p>}

                                                <input
                                                    type="password"
                                                    placeholder="Enter Confirm Password"
                                                    className={errors.confirmPassword ? "form-control shadow-none error" : "form-control shadow-none"}
                                                    {...register("confirmPassword", {
                                                        required: "Confirm Password is required",
                                                        validate: value =>
                                                            value === password.current || "The passwords do not match"
                                                    })}
                                                />
                                            </div>
                                        </div>

                                        {/* NID Number */}
                                        <div className="col-12 col-lg-6">
                                            <div className="form-group mb-4">
                                                {errors.NIDNo ? (
                                                    <p className="text-danger">{errors.NIDNo.message}</p>
                                                ) : <p>NID Number</p>}

                                                <input
                                                    type="text"
                                                    placeholder="Enter NID Number"
                                                    className={errors.NIDNo ? "form-control shadow-none error" : "form-control shadow-none"}
                                                    {...register("NIDNo", { required: "NID Number is required" })}
                                                />
                                            </div>
                                        </div>

                                        {/* Profile Image */}
                                        <div className="col-12 col-lg-6">
                                            <div className="form-group mb-4">
                                                {errors.profileImage ? (
                                                    <p className="text-danger">{errors.profileImage.message}</p>
                                                ) : <p>Profile Image</p>}

                                                <input
                                                    type="file"
                                                    id="profileImage"
                                                    className={errors.profileImage ? "form-control shadow-none error" : "form-control shadow-none"}
                                                    {...register("profileImage", { required: "Profile Image is required" })}
                                                />
                                            </div>
                                        </div>

                                        {/* NID Photo*/}
                                        <div className="col-12 col-lg-6">
                                            <div className="form-group mb-4">
                                                {errors.NIDImage ? (
                                                    <p className="text-danger">{errors.NIDImage.message}</p>
                                                ) : <p>NID Image</p>}

                                                <input
                                                    type="file"
                                                    id="NIDImage"
                                                    className={errors.NIDImage ? "form-control shadow-none error" : "form-control shadow-none"}
                                                    {...register("NIDImage", { required: "NID Image is required" })}
                                                />
                                            </div>
                                        </div>

                                        {/* Any Bill Copy Image */}
                                        <div className="col-12 col-lg-6">
                                            <div className="form-group mb-4">
                                                {errors.anyBillCopy ? (
                                                    <p className="text-danger">{errors.anyBillCopy.message}</p>
                                                ) : <p>Any Bill Copy Image </p>}

                                                <input
                                                    type="file"
                                                    id="anyBillCopy"
                                                    className={errors.anyBillCopy ? "form-control shadow-none error" : "form-control shadow-none"}
                                                    {...register("anyBillCopy", { required: "Any Bill Copy Image is required" })}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-12 text-end">
                                            <button type="submit" className="btn shadow-none text-white" disabled={isLoading}>{isLoading ? 'Creating...' : 'Create'}</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default GhotokAccount;